A position profile with the given `id`.

This query accepts browser tokens that include the `query:position-profiles` scope for posted position profiles.
Note that this scope does not grant access to the containing `PositionProfile.positionOpening`.
